import React, { useState, useEffect } from "react";
import buildingImg from "../../assets/images/building_burz.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import { DaySelector } from "./day-selector";
import { toast, Bounce } from "react-toastify";

export default function CollegeEdit({
  selectCollegeRow,
  setForceUpdate,
  forceUpdate,
  activateCollegeEdit,
  setActivateCollegeEdit,
}) {
  let navigate = useNavigate();
  let loginUser = JSON.parse(localStorage.getItem("user"));

  const { block_name, campus, id } = selectCollegeRow;

  const [campusId, setCampusId] = useState(1);
  const [blockName, setBlockName] = useState("");
  const [campusList, setCampusList] = useState([]);

  useEffect(() => {
    setCampusId(campus || "");
    setBlockName(block_name || "");
  }, [block_name, campus, activateCollegeEdit, campusList]);

  useEffect(() => {
    if (activateCollegeEdit) {
      (async () => {
        let response = await axios(`${baseUrl}/get_campus/`, {
          method: "GET",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        });
        if (response?.status === 200) {
          setCampusList(
            response?.data?.data?.map((m) => ({
              id: m?.id,
              campus_name: m?.campus_name,
            }))
          );
        }
      })();
    }
  }, [activateCollegeEdit]);

  let ChangeHandler = (e) => {
    setCampusId(e.target.value);
  };

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item, index) => item === arr2[index]);
  };

  const getChangedFields = () => {
    return {
      ...(campusId !== campus ? { campus: campusId } : {}),
      ...(blockName !== block_name ? { block_name: blockName } : {}),
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const patchData = getChangedFields();
    let response;
    try {
      response = await axios(`${baseUrl}/update_college/${id}/`, {
        method: "PATCH",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
        data: { ...patchData },
      });
      if (response?.status === 201) {
        let unique = document.getElementById("close3");
        unique.click();
        setActivateCollegeEdit(false);
        setForceUpdate(!forceUpdate);
        toast.success("Edit Block Successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <>
      <div
        className="modal fade custom-modal addcollege-modal"
        id="editcollege"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title" id="">
                Edit Block
              </h5>
              <button
                type="button"
                className="modal-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close3"
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex flex-row justify-content-center align-items-center">
                <div className="col-lg-5 text-center">
                  <div className="addbus-modal-innr">
                    <img
                      src={buildingImg}
                      width="336"
                      height="336"
                      alt="edit-college"
                    />
                    <form action="" onSubmit={handleSubmit}>
                      <div className="row justify-content-center">
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Block Name"
                            name="college_name"
                            onChange={(e) => {
                              setBlockName(e.target.value);
                            }}
                            value={blockName}
                          />
                          <span className="fa fa-solid fa-tent icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <select
                            name="college"
                            onChange={ChangeHandler}
                            className="form-select"
                            value={
                              campusList?.filter((m) => m?.id === campusId)[0]
                                ?.campus_name
                            }
                          >
                            <option>Select Campus</option>
                            {campusList.map((arr) => {
                              return (
                                <option key={arr?.id} value={arr?.id}>
                                  {arr?.campus_name}
                                </option>
                              );
                            })}
                          </select>
                          <span className="fa fa-building icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3">
                          <button className="thm-btn" type="submit">
                            Submit
                          </button>
                        </div>
                        {/* <div>
                          <DaySelector
                            initialSelectedDays={daysModal}
                            onDaysChange={setDaysModal}
                          />
                        </div> */}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {/* <div className="row justify-content-center align-items-center">
                <div className="col-lg-5 text-center">
                  <div className="addbus-modal-innr">
                    <img src={buildingImg} alt="" />
                    <form action="" onSubmit={handleSubmit}>
                      <div className="row justify-content-center">
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <select
                            name="company"
                            onChange={ChangeHandler}
                            className="form-select"
                            defaultValue={editVal?.company_name}
                          >
                            {companyNameData.map((arr) => {
                              return (
                                <option key={arr?.id} value={arr?.id}>
                                 {editVal?.company_name}
                                </option>
                              );
                            })}
                          </select>
                          <span className="fa fa-building icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Bus Number"
                            name="bus_number"
                            onChange={ChangeHandler}
                            value={editVal?.bus_number}
                          />
                          <span className="fa fa-server icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <select
                            name="depo"
                            onChange={ChangeHandler}
                            className="form-select"
                            // value={editVal?.depo_name}
                          >
                            <option >Select Depot Name</option>
                            {depoData.map((arr) => {
                              return (
                                <option key={arr?.id} value={arr?.id}  selected={editVal?.depo_name === arr.depo_name && true}>
                                  {arr.depo_name}
                                </option>
                                
                              );
                            })}
                               
                          </select>
                          <span className="fa fa-server icon" />
                        </div>
                       
                        <div className="frm-bx mb-4 col-lg-8 mb-3">
                          <button className="thm-btn" type="submit">
                          Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
